import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IFilter,
  IFilterData,
  IFilterStatusData,
  IFilterTagData,
  IFilterUserData,
} from '@pages/Products/Products';

export type DateFilters = Pick<Required<IFilter>, 'endDate' | 'startDate'>;

export const filterSlice = createSlice({
  name: 'filter',
  initialState: {
    options: {
      modelsName: [],
      manufactorNames: [],
      status: [],
      tags: [],
      users: [],
      startDate: null,
      endDate: null,
      sort: undefined,
      direction: undefined,
    } as IFilter,
    timing: {
      updatedAt: '',
      documentsUpdatedAt: 0,
    },
    // Inventory searchbarText after last onSearch.
    searchBarText: '',
    lastSearch: '',
    documentOptions: {
      manufactorNames: [] as string[],
    },
  },
  reducers: {
    updateFilterModelsName: (state, action: PayloadAction<IFilterData[]>) => {
      state.options.modelsName = action.payload;
    },
    updateFilterManufactorNames: (
      state,
      action: PayloadAction<IFilterData[]>,
    ) => {
      state.options.manufactorNames = action.payload;
    },
    updateFilterTagsName: (state, action: PayloadAction<IFilterTagData[]>) => {
      state.options.tags = action.payload;
    },
    updateFilterUsers: (state, action: PayloadAction<IFilterUserData[]>) => {
      state.options.users = action.payload;
    },
    updateFilterStatus: (state, action: PayloadAction<IFilterStatusData[]>) => {
      state.options.status = action.payload;
    },
    updateFilterStartDate: (state, action: PayloadAction<Date | null>) => {
      state.options.startDate = action.payload;
    },
    updateFilterDates: (state, action: PayloadAction<DateFilters>) => {
      state.options.startDate = action.payload.startDate;
      state.options.endDate = action.payload.endDate;
    },
    updateFilterEndDate: (state, action: PayloadAction<Date | null>) => {
      state.options.endDate = action.payload;
    },
    updateFilterSearch: (state, action: PayloadAction<string>) => {
      state.searchBarText = action.payload;
    },
    updateFilterLastSearch: (state, action: PayloadAction<string>) => {
      state.lastSearch = action.payload;
    },
    updateSort: (state, action: PayloadAction<string | undefined>) => {
      state.options.sort = action.payload;
    },
    updateSortDirection: (
      state,
      action: PayloadAction<'ASC' | 'DESC' | undefined>,
    ) => {
      state.options.direction = action.payload;
    },
    updateFilterUpdatedAt: (state, action: PayloadAction<string>) => {
      state.timing.updatedAt = action.payload;
    },
    updateDocumentsUpdatedAt: (state, action: PayloadAction<number>) => {
      state.timing.documentsUpdatedAt = action.payload;
    },
    updateDocumentsFilterManufactorNames: (
      state,
      action: PayloadAction<string[]>,
    ) => {
      state.documentOptions.manufactorNames = action.payload;
    },
    clearFilter: state => {
      state.options.modelsName = [];
      state.options.manufactorNames = [];
      state.options.tags = [];
      state.options.users = [];
      state.options.status = [];
      state.options.startDate = null;
      state.options.endDate = null;
    },
  },
});

export const {
  updateFilterModelsName,
  updateFilterManufactorNames,
  updateFilterTagsName,
  updateFilterStartDate,
  updateFilterEndDate,
  updateFilterDates,
  updateFilterSearch,
  clearFilter,
  updateSort,
  updateFilterUsers,
  updateFilterStatus,
  updateSortDirection,
  updateFilterLastSearch,
  updateFilterUpdatedAt,
  updateDocumentsUpdatedAt,
  updateDocumentsFilterManufactorNames,
} = filterSlice.actions;

export const { reducer: filterReducer } = filterSlice;
